import { ReduxStore } from "../../reducers/root_reducer";

const getSelection = (state: ReduxStore, props) => state.selection;

export default getSelection;
